var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    enableBackground: "new 0 0 25 25",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x34__stroke_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Youtube_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Youtube_4_",
    fill: "#E21717",
    d: "M21.774,9.375c0,0-0.181-1.29-0.738-1.858c-0.707-0.746-1.5-0.75-1.863-0.793 c-2.602-0.189-6.505-0.189-6.505-0.189H12.66c0,0-3.903,0-6.505,0.189C5.791,6.767,5,6.771,4.292,7.517 C3.734,8.085,3.554,9.375,3.554,9.375s-0.187,1.516-0.187,3.03v1.421c0,1.516,0.187,3.031,0.187,3.031s0.181,1.29,0.738,1.858 c0.708,0.746,1.637,0.723,2.05,0.801c1.488,0.144,6.322,0.188,6.322,0.188s3.908-0.007,6.509-0.195 c0.364-0.044,1.156-0.048,1.863-0.794c0.557-0.568,0.738-1.858,0.738-1.858s0.186-1.516,0.186-3.031v-1.421 C21.96,10.891,21.774,9.375,21.774,9.375z M10.744,15.548l0-5.261l5.024,2.64L10.744,15.548z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.3c3d0486b36aca1fc5f97f890a8264bc.svg";
export { ForwardRef as ReactComponent };